/**
 * 결제 거래 리스트 컴포넌트
 * FSD: features/subscription/payment-history/ui
 */

import React from "react";
import { useTransactions } from "../hooks/use-transactions";
import { formatAmount, formatDate } from "@/shared/lib/payment/format-amount";
import {
  getStatusBadge,
  getStatusClass,
} from "@/shared/lib/payment/payment-status";
import type { PaymentTransaction } from "@/entities/payment/model";

interface TransactionListProps {
  onSelectTransaction?: (transaction: PaymentTransaction) => void;
}

export const TransactionList: React.FC<TransactionListProps> = ({
  onSelectTransaction,
}) => {
  const { data: transactions, isLoading, error } = useTransactions();

  if (isLoading) return <div className="loading">로딩 중...</div>;
  if (error)
    return <div className="error">오류: {(error as Error).message}</div>;
  if (!transactions || transactions.length === 0) {
    return <div className="empty-state">결제 내역이 없습니다.</div>;
  }

  return (
    <div className="transaction-list">
      <table className="transaction-table">
        <thead>
          <tr>
            <th>결제일시</th>
            <th>상품명</th>
            <th>금액</th>
            <th>상태</th>
            <th>결제수단</th>
            <th>승인번호</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction) => (
            <tr
              key={transaction.id}
              onClick={() => onSelectTransaction?.(transaction)}
              className="transaction-row"
            >
              <td>{formatDate(transaction.created_at)}</td>
              <td>{transaction.goods_name}</td>
              <td>{formatAmount(transaction.amount)}</td>
              <td>
                <span className={`badge ${getStatusClass(transaction.status)}`}>
                  {getStatusBadge(transaction.status)}
                </span>
              </td>
              <td>{transaction.pay_method}</td>
              <td>{transaction.approval_number || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
